// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3_iOL","overflowing":"ReadFullNote_overflowing__1J4rt"};